import { AxiosResponse } from 'axios'
import { http } from '../api'
const controller = 'items'
export async function getPaginate(page: number, size: number, part_number?: number): Promise<any> {
    const url = `${controller}/?page=${page}&page_length=${size}${part_number ? `&part_number=${part_number}` : ''}`;
    const { data } = await http.get<any, AxiosResponse>(url);
    return data;
}
export async function getBy(id: string): Promise<any> {
    const { data } = await http.get<any, AxiosResponse>(`${controller}/${id}`)
    return data;
}
export async function getMonthItems(page?: number, size?: number): Promise<any>
{
    const { data } = await http.get<any, AxiosResponse>(`${controller}/month-items?u=u${page ? `&page=${page}` : ''}${size ? `&page_length=${size}` : ''}`);
    return data;
}
export async function updateMonthItems(payload: { items: object[] }): Promise<any>
{
    const { data } = await http.post<any, AxiosResponse>(`${controller}/month-items`, payload);
    return data;
}
